//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VeLine from 'v-charts/lib/line.common'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'VisitList',
  components: { VeLine },
  data() {
    return {
      user: window.user,
      selected: '1',
      visit: {},
      chartExtend: {
        color: ['red', 'blue'],
        yAxis: {
          min: 'dataMin'
        }
      },
      axisChartData: {
        columns: ['日期', '左眼', '右眼'],
        rows: [
        ]
      },
      visionChartData: {
        columns: ['日期', '左眼', '右眼'],
        rows: [
        ]
      },
      diopter_0_ChartData: {
        columns: ['日期', '左眼', '右眼'],
        rows: [
        ]
      },
      diopter_1_ChartData: {
        columns: ['日期', '左眼', '右眼'],
        rows: [
        ]
      },
      diopter_2_ChartData: {
        columns: ['日期', '左眼', '右眼'],
        rows: [
        ]
      }
    }
  },
  mounted() {
    this.getVisits()
  },
  methods: {
    getDate (createdAt) {
      console.log(createdAt)
      if (!createdAt) {
        return ''
      }
      return moment(createdAt).format('YY/MM/DD')
    },
    getVisits () {
      axios.get('/api/admin/visits/all', {
        params: {
          openid: this.$route.params.id
        }
      })
      .then((res) => {
        if (res.data.code === 0) {
          this.list = res.data.data.visits
          this.visit = res.data.data.visits[res.data.data.visits.length - 1] || {}
          let axisChartData = Object.assign({}, this.axisChartData)
          let visionChartData = Object.assign({}, this.visionChartData)
          let diopter_0_ChartData = Object.assign({}, this.diopter_0_ChartData)
          let diopter_1_ChartData = Object.assign({}, this.diopter_1_ChartData)
          let diopter_2_ChartData = Object.assign({}, this.diopter_2_ChartData)
          axisChartData.rows = this.list.map((visit, index) => {
            return {
              '日期': this.getDate(visit.recordedAt),
              '左眼': visit.axis_os,
              '右眼': visit.axis_od
            }
          })
          visionChartData.rows = this.list.map((visit, index) => {
            return {
              '日期': this.getDate(visit.recordedAt),
              '左眼': visit.vision_os,
              '右眼': visit.vision_od
            }
          })

          diopter_0_ChartData.rows = this.list.map((visit, index) => {
            return {
              '日期': this.getDate(visit.recordedAt),
              '左眼': visit.diopter_os_sph,
              '右眼': visit.diopter_od_sph,
            }
          })
          diopter_1_ChartData.rows = this.list.map((visit, index) => {
            return {
              '日期': this.getDate(visit.recordedAt),
              '左眼': visit.diopter_os_cyl,
              '右眼': visit.diopter_od_cyl
            }
          })
          diopter_2_ChartData.rows = this.list.map((visit, index) => {
            return {
              '日期': this.getDate(visit.recordedAt),
              '左眼': visit.diopter_os_axis,
              '右眼': visit.diopter_od_axis
            }
          })

          this.axisChartData = axisChartData
          this.visionChartData = visionChartData
          this.diopter_0_ChartData = diopter_0_ChartData
          this.diopter_1_ChartData = diopter_1_ChartData
          this.diopter_2_ChartData = diopter_2_ChartData
        }
      })
    }
  }
}
